// App-level messages: initial loading text and other cross-cutting strings.
const messages = {
  en: {
    'messages.loadingApp': 'Loading Happy Tomato…',
    'messages.loadingSession': 'Loading session…',
    'messages.loadingCalendar': 'Loading your calendar…',
    'messages.loadingData': 'Loading…',
    'messages.saving': 'Saving…',
    'messages.deleting': 'Deleting…',
    'messages.loadingEventDetails': 'Loading event details…',
    'messages.appErrorTitle': 'Application Error',
    'messages.appErrorBody': 'The calendar application encountered an unexpected error.',
  },
  lt: {
    'messages.loadingApp': 'Kraunama „Happy Tomato“…',
    'messages.loadingSession': 'Kraunama sesija…',
    'messages.loadingCalendar': 'Kraunamas kalendorius…',
    'messages.loadingData': 'Kraunama…',
    'messages.saving': 'Išsaugoma…',
    'messages.deleting': 'Trinama…',
    'messages.loadingEventDetails': 'Kraunama įvykio informacija…',
    'messages.appErrorTitle': 'Programos klaida',
    'messages.appErrorBody': 'Kalendoriaus programoje įvyko netikėta klaida.',
  },
};

export default messages;
